const PREFIX = 'QS_';

/**
 * @name APPLY_HASH_CHANGE
 * @const
 * @description Applies hash changes that apply to filters
 */
export const APPLY_HASH_CHANGE = PREFIX + 'APPLY';

/**
 * @name APPLY_RESET_QUICK_FILTERS
 * @const
 * @description Applies reset to quick filters
 */
 export const APPLY_RESET_QUICK_FILTERS = 'RESET QUICK FILTERS';